import './partner.scss';
import 'slick-carousel';
export default () => {
  $('.js-partner-slider').slick({
    rows: 0,
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<div class="prev-arrow" ><a aria-label="Vorige slide"><i class="icon-arrow-left" title="Vorige slide"></i></a></div>',
    nextArrow: '<div class="next-arrow" ><a aria-label="Volgende slide"><i class="icon-arrow-right" title="Volgende slide"></i></a></div>',
    responsive: [{
      breakpoint: 1023,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 639,
      settings: {
        slidesToShow: 1
      }
    }]
  });
};